import React from 'react';
import { connect } from 'react-redux';
import InvoiceImportCSV from './InvoiceImportCSV';
import { fileDelete } from '../../lib/redux/actions/invoiceBatchFiles';

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  ...state.invoiceBatchFiles,
});

const mapDispatchToProps = {
  fileDelete,
};

class InvoiceImportCSVContainer extends React.Component {
  render() {
    const { files, fileDelete, fileRequestInProgress } = this.props;

    return <InvoiceImportCSV files={files} fileDelete={fileDelete} fileRequestInProgress={fileRequestInProgress} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceImportCSVContainer);
